export default {
    methods: {
        flashMsg(message, type = 'success') {
            this.$page.props.flash[type] = message
        },
        dismissMsg(type = 'success') {
            this.$page.props.flash[type] = null
        },
    }
}
